import React from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';

import LabelName from 'components/UI/LabelName/LabelName';
import { reminderChannels, reminderCountOptions, reminderCustomOptions, reminderOptions } from 'constants/dropdownOptions';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

function AddRemindersV2({ watch, control, isGlobal, errors, setValue, isRequired, optionText = '' }) {
  const { fields, insert, remove } = useFieldArray({
    control,
    name: 'reminder',
    rules: {
      validate: (value) => ((value && value.length > 0) || !isRequired ? true : 'Please add at least one reminder.'),
    },
  });

  function onAddReminder() {
    insert(fields.length, { value: '30#minutes#', reminder_channel_type: 'inapp_notification' });
  }
  function onDeleteReminder(index) {
    remove(index);
  }

  const caseId = watch('case') || watch('case_id');

  const toFirstCap = (v) => (typeof v === 'string' && v ? v.charAt(0).toUpperCase() + v.slice(1).toLowerCase() : v);

  return (
    <div className="d-flex flex-wrap w-100 pb-2">
      <div className="col-md-4 col-12 mt-2">
        <LabelName required={isRequired}>Reminders</LabelName>
      </div>
      <div className="col-md-8 col-12 mt-2">
        {fields?.length > 0 &&
          fields.map((data, index) => {
            let reminderValue = watch(`reminder.${index}.value`);
            return (
              <div className="d-flex input-shadow align-items-center justify-content-center p-2 mb-2 bg-grey mt-2" key={data.id}>
                <div className="w-100">
                  <div>
                    <Controller
                      name={`reminder.${index}.reminder_channel_type`}
                      control={control}
                      render={({ field }) => (
                        <Dropdown
                          placeholder="Channel"
                          name={field.name}
                          id={field.name}
                          value={field.value}
                          onChange={(e) => field.onChange(e.value)}
                          options={
                            reminderChannels?.filter((item) => !(item?.value === 'secure_message' && !Boolean(caseId) && isGlobal)) || []
                          }
                          className="w-100"
                          filter
                        />
                      )}
                    />
                  </div>
                  <div className="mt-2">
                    <Controller
                      name={`reminder.${index}.value`}
                      control={control}
                      render={({ field }) => (
                        <Dropdown
                          placeholder="Add"
                          name={field.name}
                          id={field.name}
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                            if (e.value === 'custom') {
                              setValue(`reminder.${index}.customValue`, 1);
                              setValue(`reminder.${index}.minutes`, 'minutes');
                              setValue(`reminder.${index}.type`, 'minutes');
                              setValue(`reminder.${index}.past_due`, '');
                            } else {
                              setValue(`reminder.${index}.customValue`, null);
                              setValue(`reminder.${index}.minutes`, null);
                              setValue(`reminder.${index}.type`, null);
                              setValue(`reminder.${index}.past_due`, null);
                            }
                          }}
                          options={reminderOptions?.map((item) => ({
                            ...item,
                            label: item?.value === 'custom' ? item.label : `${item?.label} ${optionText}`,
                          }))}
                          className="w-100"
                          filter
                        />
                      )}
                    />
                  </div>

                  {reminderValue === 'custom' && (
                    <div className="d-flex flex-column">
                      <div className="d-flex mt-2 gap-2">
                        <Controller
                          name={`reminder.${index}.customValue`}
                          control={control}
                          defaultValue={1}
                          render={({ field }) => {
                            const countOptionValues = reminderCountOptions.map((o) => o.value);
                            const valueInOptions = field.value != null && countOptionValues.includes(field.value);
                            const displayValue = valueInOptions ? field.value : 1;
                            return (
                              <Dropdown
                                placeholder={displayValue}
                                name={field.name}
                                id={field.name}
                                className="w-100"
                                value={displayValue}
                                onChange={(e) => {
                                  const v = e.value;
                                  field.onChange(v != null && v !== '' ? v : 1);
                                }}
                                options={reminderCountOptions}
                                filter
                              />
                            );
                          }}
                        />

                        <Controller
                          name={`reminder.${index}.type`}
                          control={control}
                          defaultValue="minutes"
                          render={({ field }) => {
                            const typeOptionValues = reminderCustomOptions.map((o) => o.value);
                            const valueInOptions = field.value != null && field.value !== '' && typeOptionValues.includes(field.value);
                            const displayValue = valueInOptions ? field.value : 'minutes';
                            return (
                              <Dropdown
                                placeholder={toFirstCap(displayValue)}
                                name={field.name}
                                id={field.name}
                                value={displayValue}
                                onChange={(e) => {
                                  const v = e.value;
                                  field.onChange(v != null && v !== '' ? v : 'minutes');
                                }}
                                options={reminderCustomOptions}
                                filter
                              />
                            );
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div
                  onClick={(e) => {
                    onDeleteReminder(index);
                  }}
                  className="pointer"
                  style={{ marginLeft: '0.5rem' }}
                >
                  <i className="pi icon-delete"></i>
                  <Tooltip content="Delete Reminder" position="top" target=".icon-delete" showDelay={500} />
                </div>
              </div>
            );
          })}
        <div className="mt-2 ">
          <span className="pointer call-back" onClick={onAddReminder}>
            + Add Reminder
          </span>
        </div>
      </div>
      <div className="offset-md-4">
        {errors?.reminder?.root?.type === 'validate' && <InputErrorMessage>{errors?.reminder?.root?.message}</InputErrorMessage>}
      </div>
    </div>
  );
}

export default AddRemindersV2;
